import { render } from "./MirabelPagination.vue?vue&type=template&id=829e4f20&scoped=true"
import script from "./MirabelPagination.vue?vue&type=script&lang=js"
export * from "./MirabelPagination.vue?vue&type=script&lang=js"

import "./MirabelPagination.vue?vue&type=style&index=0&id=829e4f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829e4f20"]])

export default __exports__